import {ClientTypes, Client, LaunchDarklyClient, EvidentlyClient} from './featuretoggle';
import {EvidentlyConfig, CognitoConfig} from './featuretoggle/types/config';

export * from './featuretoggle/types';
export * from './featuretoggle/hooks';

const clients = {
    LAUNCHDARKLY: LaunchDarklyClient,
    EVIDENTLY: EvidentlyClient,
};

export const getFeatureToggleClient = async (
    type: ClientTypes,
    evidentlyConfig?: EvidentlyConfig,
    cognitoConfig?: CognitoConfig
): Promise<Client> => {
    if (type === ClientTypes.evidently) {
        const client = new clients[type]();
        await client.configure(evidentlyConfig, cognitoConfig);
        return client;
    } else {
        return new clients[type]();
    }
};
